/**
 * Created by roger.s on 2017/7/4.
 */

import Vue from 'vue'

export default {
  info: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/info', {
      params: params
    })
  },
  create: function (params) {
    return Vue.http.get(Vue.prototype.serverUrl + 'deposit/create', {
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/models/models/Deposit.js